import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import Custom from './custom'

/**
 * This store will be used for all modules of this component
 */
const state = {
  commonObj: {
      hasDropdownLoaded: false,
      genderList: Custom.genderList,
      assessmentToolsList: [],
      committeeList: [],
      lessonPlanNameList: [],
      courseNameList: [],
      classList: [],
      trainingTitleList: [],
      transportNameList: [],
      libraryBookList: [],
      religionList: Custom.religionList,
      curricularTypeList: [],
      yearList: Custom.yearList,
      studentTypeList: Custom.studentTypeList,
      designationList: [],
      payGradeList: [],
      hostelList: [],
      IepSlotList: [],
      gradeList: [],
      traineeTypeList: Custom.traineeTypeList,
      disabilityTypeList: []
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
